<template>
    <div>
        <v-select :disabled="disabled" variant=outlined density="compact" v-model="internal_project" :items="projects"
            :label="label" item-value="uuid" item-title="name" :multiple="multiple != undefined" />
    </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useCompanyStore } from "@/stores/company";
import { nameSort } from "/src/utils/basics.js";


const internal_project = defineModel()

const { disabled, only_stdlibs, include_archived, multiple } = defineProps(["disabled", "only_stdlibs", "include_archived", "multiple"])


const company_store = useCompanyStore()
const projects = computed(() => {
    let items = []
    if (only_stdlibs != undefined) {
        items = company_store.standard_libraries
    } else if (include_archived != undefined) {
        items = company_store.projects_and_stdlibs_with_archived
    } else {
        items = company_store.projects_and_stdlibs
    }
    items = items.map(p => ({ uuid: p.uuid, name: p.super_project ? `[${p.super_project}] ${p.name}` : p.name }))
    items.sort((a, b) => nameSort(a.name, b.name))
    return items
})

const label = computed(() => {
    let label = "Project"
    if (multiple != undefined) {
        if (only_stdlibs != undefined) {
            label = "Standard Libraries"
        } else {
            label = "Projects"
        }
    } else if (only_stdlibs != undefined) {
        label = "Standard Library"
    }

    return label

})

onMounted(() => {
    if (include_archived != undefined && company_store.archived_projects.length == 0) {
        company_store.loadArchivedProjects()
    }
})

</script>